import {
  GESTION_OPERATIVA_UPDATE_SALE_BEGIN,
  GESTION_OPERATIVA_UPDATE_SALE_SUCCESS,
  GESTION_OPERATIVA_UPDATE_SALE_FAILURE,
  GESTION_OPERATIVA_UPDATE_SALE_DISMISS_ERROR
} from './constants'
import { BFFAgent } from '../../../common/BFFAgent'
import * as commonActions from '../../common/redux/actions'
const ORIGIN_CHANNEL_NAME_ZERO_KM = '0km'
const ORIGIN_CHANNEL_NAME_USADOS = 'Usados'

export function updateSale(sale) {
  return async dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: GESTION_OPERATIVA_UPDATE_SALE_BEGIN
    })

      // Lógica para actualizar los valores de ingreso de los vehículos usados
      const selectedOrigChan = sale.auto?.nuevo ? ORIGIN_CHANNEL_NAME_ZERO_KM : ORIGIN_CHANNEL_NAME_USADOS
      const originChannels = await BFFAgent.Peritador.getOriginChannels() || []
      const currentOriginChannel =
        originChannels.find((origChan) => origChan?.name?.toLowerCase() === selectedOrigChan?.toLowerCase())
      sale.Taking_cars.forEach((car) => {
        car.origin_channel_id = currentOriginChannel?.id
        car.car_lot_id = sale.auto?.car_lot_id
        car.branch_office_id = sale.branch_office_id
      })

      try {
       const res = await BFFAgent.Sales.updateSale(sale.id, sale)
          dispatch({
            type: GESTION_OPERATIVA_UPDATE_SALE_SUCCESS,
            data: { sale }
          })
          dispatch(
            commonActions.SuccessAction({
              title: 'Los cambios se guardaron con éxito',
            }))
          return res
        // Use rejectHandler as the second argument so that render errors won't be caught.
      } catch (err) {
          dispatch({
            type: GESTION_OPERATIVA_UPDATE_SALE_FAILURE,
            data: { error: err }
          })
          const genericErrorMessage = 'Error al guardar los cambios'
          const dispatchTitle = err?.response?.data?.statusCode === 409 ? err.response.data.message : genericErrorMessage
          dispatch(
            commonActions.ErrorAction({
              title: dispatchTitle
            }))
      }
  }
}

export function dismissUpdateSaleError() {
  return {
    type: GESTION_OPERATIVA_UPDATE_SALE_DISMISS_ERROR
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case GESTION_OPERATIVA_UPDATE_SALE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updateSalePending: true,
        updateSaleError: null
      }

    case GESTION_OPERATIVA_UPDATE_SALE_SUCCESS:
      // The request is success
      return {
        ...state,
        updateSalePending: false,
        updateSaleError: null,
        isModified: false,
        sale: { ...action.data.sale },
        initialBonEspecial: action.data.sale?.special_discount,
        initialBonAdicional: action.data.sale?.additional_discount,
        savedSale: true
      }

    case GESTION_OPERATIVA_UPDATE_SALE_FAILURE:
      // The request is failed
      return {
        ...state,
        updateSalePending: false,
        updateSaleError: action.data.error,
      }

    case GESTION_OPERATIVA_UPDATE_SALE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updateSaleError: null
      }

    default:
      return state
  }
}
